import * as React from 'react'
import  styled, { css } from 'styled-components'

type defineKerningSetting ={
  type: string;
  target: RegExp;
  styles: string;
} | undefined

type stringsData = {
  text: string | undefined;
  type: string | undefined;
  styles: string;
}

type KspanProps = {
  styles: string
}

const Kspan = styled.span<KspanProps>`${props => props.styles.trim()}`
class kerning {
  define: Array<defineKerningSetting>
  
  constructor(defineArgs:Array<defineKerningSetting> = [undefined] ) {
    this.define = [...defineArgs]
  }

  set defineTypes (define:Array<defineKerningSetting>){
    this.define = define
  }

  get defaultDefine(): Array<defineKerningSetting> {
    return [
      {
        type: 'a',
        target: new RegExp(/[\w/:.-]*/),
        styles: `
          margin:0 4px 0 0;
        `
      },
      {
        type: 'space',
        target: new RegExp(/[\s]*/),
        styles: `
          margin: 0px 0 0 -4px;
        `
      },
      {
        type: 'symbol',
        target: new RegExp(/[!"#$%&'()*+,;<=>?@[\\\]^_`{|}~]*/),
        styles: `
          margin: 0 0px 0 0 ;
        `
      },
      {
        type: '記号',
        target: new RegExp(/[・、。]*/),
        styles: `
          margin:0px 7px 0px -4px;
        `
      },
      {
        type: 'カッコ開き',
        target: new RegExp(/[（〔［｛〈《「『【＜]*/),
        styles: `
          margin: 0 0 0 4px;
        `
      },
      {
        type: 'カッコ閉じ',
        target: new RegExp(/[）〕］｝〉》」』】＞]*/),
        styles: `
          margin: 0 0 0 -4px;
        `
      },
      {
        type: 'あ',
        target: new RegExp(/[^\\x01-\\x7E\\xA1-\\xDF]*/),
        styles: `
          margin:0 4px 0 0;
        `
      },
    ]
  }

  create = (arg: TemplateStringsArray,...placeholders: string[]):React.ReactNode|undefined => {
    const typeDefine: Array<defineKerningSetting> = this.define
    const strings: Array<string> = [...arg[0] || placeholders[0]]
    
    let chunks:Array<stringsData> = []
    const textDataD:stringsData = {
      text: '',
      type: '',
      styles: '',
    }
    let textData = textDataD
    let currentCharType: string | undefined = undefined
    let currentCharStyles: string | undefined = undefined
    let prevCharType: string | undefined  = undefined
    strings.forEach((char: string, i: number) => {
      for (const type of typeDefine) {
        if (type?.target !== undefined) {
          const match = char.match(type.target)
          if(match !== null && match[0] == char){
            currentCharType = type.type
            currentCharStyles = type.styles
            break
          }
        }
      }
      if (currentCharType !== undefined && currentCharStyles !== undefined) {
        if (i < 1 || currentCharType === prevCharType) {
          textData.text += char
        } else if (currentCharType !== prevCharType) {
          chunks = [...chunks, textData]
          textData = { ...textDataD }
          textData.text = char
        }
        textData.type = currentCharType
        textData.styles = currentCharStyles
        if (i == [...strings].length - 1) {
          chunks = [...chunks, textData]
        }
        prevCharType = currentCharType
      }
    })

    return (
      <>
        {
          chunks.map((c, i) => {
            return (  
              <Kspan styles={c.styles} key={i} >{c.text}</Kspan>
            )
          })
        }
      </>
    )
  } 
}


export const KString: React.FC<React.ReactNode> = ({children})=> {
  const k = new kerning()

  k.defineTypes = [
    {
      type: 'postal-mark',
      target: new RegExp(/[〒]*/),
      styles: `
        margin: 0 0px 0 0 ;
      `
    },
    {
      type: 'nakaguro',
      target: new RegExp(/[・]*/),
      styles: `
        margin: 0 4px 0 0 ;
      `
    },
    {
      type: 'カギカッコopen',
      target: new RegExp(/[「]*/),
      styles: `
        margin: 0 0 0 4px;
      `
    },
    {
      type: 'カギカッコclose',
      target: new RegExp(/[」]*/),
      styles: `
        margin: 0px 8px 0px -4px;
      `
    },
    {
      type: 'スミカッコopen',
      target: new RegExp(/[【]*/),
      styles: `
        margin: 0 0 0 4px;
      `
    },
    ...k.defaultDefine,
  ]

  const R:any = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      if(child.type === 'img'){
        return React.createElement(
          child.type,
          {...child.props}
        )
      }
      return React.createElement(
        child.type,
        {...child.props},
        KString(child.props)
      )
    }else{
      if (typeof child == 'string') {
        return k.create`${child}`
      } else {
        return child
      }
    }
  })

  return R
}

export default kerning